import { render, staticRenderFns } from "./ReportPaymentWidget.vue?vue&type=template&id=78f2e296&scoped=true&"
import script from "./ReportPaymentWidget.vue?vue&type=script&lang=js&"
export * from "./ReportPaymentWidget.vue?vue&type=script&lang=js&"
import style0 from "./ReportPaymentWidget.vue?vue&type=style&index=0&id=78f2e296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f2e296",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78f2e296')) {
      api.createRecord('78f2e296', component.options)
    } else {
      api.reload('78f2e296', component.options)
    }
    module.hot.accept("./ReportPaymentWidget.vue?vue&type=template&id=78f2e296&scoped=true&", function () {
      api.rerender('78f2e296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/ReportPaymentWidget.vue"
export default component.exports